import React from 'react'
import MemberSignup from '@cmp/templates/MemberSignup'
import requiresLogin from '@cmp/site/RequiresLogin'

export default requiresLogin(() => <MemberSignup />)
